import { appStore } from '@pendwa/common-browser/core/appStore/index.js';
import { logger } from '@pendwa/common-browser/core/logger/index.js';
import isValidPath from 'is-valid-path';
import moment from 'moment';

/**
 * we have an expiration on this key, NO NEED TO REMOVE IT MANUALLY
 */
const KEY_NEXT_PATH = 'n-snp';

export const recordSignInNextPathFromURL = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const next: string | undefined = searchParams.get('next') || undefined;

  if (next) {
    appStore.set(KEY_NEXT_PATH, {
      next,
      date_time: Date.now(),
    });
  }
};

export const getSignInNextPath = (): { next: string | undefined } => {
  const searchParams = new URLSearchParams(window.location.search);
  const next_from_search_params: string | undefined = searchParams.get('next') || undefined;

  if (next_from_search_params) {
    return {
      next: next_from_search_params,
    };
  }

  const value = appStore.get(KEY_NEXT_PATH);

  try {
    if (value) {
      const { next, date_time } = value;
      return {
        next:
          next && isValidPath(next) && moment.duration(moment().diff(moment(date_time))).asMinutes() <= 5
            ? next
            : undefined,
      };
    } else {
      return {
        next: undefined,
      };
    }
  } catch (error) {
    logger.error(
      new Error('could not get/parse next from appStore', {
        cause: error,
      })
    );
    appStore.remove(KEY_NEXT_PATH);
    return {
      next: undefined,
    };
  }
};
